/**
 * View component for /user-profiles/:userProfileId/update
 *
 * Updates a single userProfile from a copy of the selcted userProfile
 * as defined in the userProfile reducer
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { history, withRouter } from 'react-router-dom';
import { Helmet } from 'react-helmet';

// import third-party libraries
import _ from 'lodash';

// import actions
import * as userProfileActions from '../userProfileActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";

// import module components
import UserProfileForm from '../components/UserProfileForm.js.jsx';
import UserProfileLayout from '../components/UserProfileLayout.js.jsx';

// import userProfile css modules
import userProfileStyles from '../userProfileModuleStyles.css';

class UpdateUserProfile extends Base {
  constructor(props) {
    super(props);
    const { selectedUserProfile, userProfileMap } = this.props;
    this.state = {
      userProfile: userProfileMap[selectedUserProfile.id] ? { ...userProfileMap[selectedUserProfile.id] } : {}
      // NOTE: we don't want to change the store, just make changes to a copy
    }
    this._bind(
      '_handleFormChange'
      , '_handleFormSubmit'
    );
  }

  componentDidMount() {
    const { dispatch, match } = this.props;
    dispatch(userProfileActions.fetchSingleIfNeeded(match.params.userProfileId))
  }

  componentWillReceiveProps(nextProps) {
    const { selectedUserProfile, userProfileMap } = nextProps;
    this.setState({
      userProfile: userProfileMap[selectedUserProfile.id] ? { ...userProfileMap[selectedUserProfile.id] } : {}
      //we don't want to actually change the store's userProfile, just use a copy
    })
  }

  _handleFormChange(e) {
    let newUserProfileState = _.update( this.state.userProfile, e.target.name, function() {
      return e.target.value;
    });
    this.setState({userProfile :newUserProfileState});
  }

  _handleFormSubmit(e) {
    const { dispatch, history } = this.props;
    e.preventDefault();
    dispatch(userProfileActions.sendUpdateUserProfile(this.state.userProfile)).then((action) => {
      if(action.success) {
        history.push(`/user-profiles/${action.item._id}`)
      } else {
        // console.log("Response Error:");
        // console.log(action);
        alert("ERROR - Check logs");
      }
    });
  }

  render() {
    const { selectedUserProfile, userProfileMap } = this.props;
    const { userProfile } = this.state;
    const isEmpty = (!userProfile || userProfile._id === null || userProfile._id === undefined);
    return  (
      <UserProfileLayout>
        <div className="flex"> 
        <Helmet
          title={"Update User Profile | Pro-ficiency"}
        />
          <section className="section">
            {isEmpty ?
              (selectedUserProfile.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
              :
              <UserProfileForm
                userProfile={userProfile}
                cancelLink={`/user-profiles/${userProfile._id}`}
                formTitle="Update User Profile"
                formType="update"
                handleFormChange={this._handleFormChange}
                handleFormSubmit={this._handleFormSubmit}
              />
            }
          </section>
        </div>
      </UserProfileLayout>
    )
  }
}

UpdateUserProfile.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
  * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
  * differentiated from the React component's internal state
  */
  return {
    selectedUserProfile: store.userProfile.selected
    , userProfileMap: store.userProfile.byId
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(UpdateUserProfile)
);



// WEBPACK FOOTER //
// modules/userProfile/views/UpdateUserProfile.js.jsx